import { isFunction } from 'lodash';

import { store as Classes } from './classes';
import { store as Auth } from './auth';
import BrowseFilters from './browse-filters';
import Notifications from './notifications';
import { store as viewerCards } from './viewer-cards';
import { store as viewerPages } from './viewer-pages';
import { store as viewerNewClassPages } from './viewer-newclass-pages';
import { store as viewerQuizzes } from './viewer-quizzes';
import { store as viewerResults } from './viewer-results';
import { store as viewerCatCard } from './viewer-cat-cards';
import { store as viewerCatIntro } from './viewer-cat-intro';
import { store as viewerCatPages } from './viewer-cat-pages';
import { store as viewerCatQuizzes } from './viewer-cat-quizzes';
import { store as viewerCatResults } from './viewer-cat-results';
import { store as viewerPreview } from './viewer-preview';
import { store as questionPage } from './question-page';
import { store as sharedPage } from './shared-page';
import { store as journey } from './journey';
import { store as user } from './user';
import { store as quizBookmark } from './quiz-bookmark';

const store = {
  BrowseFilters,
  Notifications,
  Classes,
  Auth,
  viewerCards,
  viewerPages,
  viewerNewClassPages,
  viewerQuizzes,
  viewerResults,
  viewerCatCard,
  viewerCatIntro,
  viewerCatPages,
  viewerCatQuizzes,
  viewerCatResults,
  viewerPreview,
  questionPage,
  sharedPage,
  journey,
  user,
  quizBookmark,
};
const keys = Object.keys(store);

const modules = keys.reduce((acc, key) => ({ ...acc, [key]: store[key].module }), {});
const plugins = keys.reduce((acc, key) => [...acc, store[key].plugin], []).filter(isFunction);

export default { modules, plugins };
